import { render, staticRenderFns } from "./StudentCheckPaper.vue?vue&type=template&id=dbd0a0a4&scoped=true"
import script from "./StudentCheckPaper.vue?vue&type=script&lang=js"
export * from "./StudentCheckPaper.vue?vue&type=script&lang=js"
import style0 from "./StudentCheckPaper.vue?vue&type=style&index=0&id=dbd0a0a4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd0a0a4",
  null
  
)

export default component.exports